<section class="flex justify-content-center mt-4">
    <div class="card-table col-12 flex flex-column">
        <div class="pt-1">
            <CustomTitle [title]="'msg.gestionPQRSD' | translate" [showTag]="false"
                         styleClass=" font-principal app-title-page-color font-medium font-23 mt-4  text-uppercase  mb-0" />
        </div>
        <p-tabView [(activeIndex)]="activeTabIndex" (activeIndexChange)="activeIndexChange($event)">
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <div class="flex gap-1 align-items-center">
                        <span>
                            {{'common.pendientes' |translate}}
                        </span>
                    </div>
                </ng-template>
                <app-pqrsd-gestionar-actividades-pendientes [tramEstados]="['ACTIVO']" [tramActividadEstados]="['PENDIENTE']"></app-pqrsd-gestionar-actividades-pendientes>
            </p-tabPanel>
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <div class="flex gap-1 align-items-center">
                        <span>
                            {{'common.finalizados' |translate}}
                        </span>
                    </div>
                </ng-template>
                <app-pqrsd-gestionar-actividades-pendientes [tramEstados]="['FINALIZADO','RECHAZADO']" [tramActividadEstados]="['FINALIZADO','REASIGNADO','REABIERTO']"></app-pqrsd-gestionar-actividades-pendientes>
            </p-tabPanel>
        </p-tabView>
    </div>
</section>
